<template>
    <div class="panel settings-panel" :class="{ 'panel-custom panel-border' : borderTop }">
        <div class="panel-heading">
            <slot name="title">
                <h3 class="header-title">{{ title }}</h3>
            </slot>
            <slot name="description">
                <p class="help-block text-muted m-b-0">{{ description }}</p>
            </slot>
        </div>

        <div class="panel-body">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SettingsPanel',

    props: {
        title: {
            required: false,
            default: null
        },

        borderTop: {
            required: false,
            default: true
        },

        description: {
            required: false,
            default: null,
        }
    }
}
</script>

<style>
.settings-panel > .panel-body .setting:last-child {
    margin-bottom: 0px;
}
</style>
